import React from 'react'
import { chartColors } from '../helpers/const'
import { calculatePercentage } from '../helpers/functions'

const ChartLabels = ({ index, item, total }) => {
  if (item.value === 0) return null

  return (
    <React.Fragment>
      <p className="flex flex-center mb1 mt1" key={item.name}>
        <span
          className="circle inline-block mr1"
          style={{ backgroundColor: chartColors[index % chartColors.length], height: '15px', minWidth: '15px', width: '15px' }}
        />

        <span>
          {item.name} - <b>&nbsp;{calculatePercentage(total, item.value)}%</b>
        </span>
      </p>
    </React.Fragment>
  );
}

export default ChartLabels
